import Vue from 'vue';
// we need our modal component
import MessageModal from './MessageModal.vue'
import { MODAL_MODE } from './modalMode'

// 1. Initialize the EventBus as a standalone constant
export const ModalEventBus = new Vue();

const MessageModalPlugin = {
  // every plugin for Vue.js needs install method
  // this method will run after Vue.use(<your-plugin-here>) is executed
  install (VueInstance) {
    // 2. Register global component
    VueInstance.component('message-modal', MessageModal)

    // Core method to emit showModal event
    const emitShowModal = (params = {}) => {
      ModalEventBus.$emit('showModal', params);
    };

    // 3. Define shorthand helper methods on $message
    VueInstance.prototype.$message = {
      // General call
      showModal: emitShowModal,

      // Helper for Info/Alert only (Mode: NORMAL, hasCancel: false)
      info(params = {}) {
        emitShowModal({
          ...params,
          mode: MODAL_MODE.NORMAL,
          hasCancel: false
        });
      },

      // Helper for Standard Confirmation (Mode: NORMAL, hasCancel: true)
      confirm(params = {}) {
        emitShowModal({
          ...params,
          mode: MODAL_MODE.NORMAL,
          hasCancel: true
        });
      },

      // Helper for Exact Text Matching Confirmation (Mode: MATCH_TEXT)
      matchText(params = {}) {
        emitShowModal({
          ...params,
          mode: MODAL_MODE.MATCH_TEXT
        });
      },

      // Helper for Text/Password Input Prompt (Mode: REQUIRE_INPUT)
      prompt(params = {}) {
        emitShowModal({
          ...params,
          mode: MODAL_MODE.REQUIRE_INPUT
        });
      }
    };

    // 4. (Optional) Directly attach shortcut methods to Vue prototype if you prefer 'this.$confirmMatch' style
    VueInstance.prototype.$confirmMatch = function(params = {}) {
      emitShowModal({
        ...params,
        mode: MODAL_MODE.MATCH_TEXT
      });
    };
  }
}

export default MessageModalPlugin

// Usage
// Add these lines into main.js
//   import MessageModal from './messagemodal'
//   Vue.use(MessageModal)
// Add follwing line into App.vue, inside vue decalaration
//   <message-modal />
// Showing message
//   1. Info message
//   showAlert() {
//     this.$message.info({
//       message: 'Save data successfully!'
//     });
//   },

//   // 2. Confirm message
//   showConfirm() {
//     this.$message.confirm({
//       message: 'Do you want to leave?',
//       onConfirm: this.handleLeavePage
//     });
//   },

//   // 3. Confirm with match text
//   showDeleteConfirm() {
//     this.$message.matchText({
//       title: 'Delete warning',
//       message: 'This action cannot be undo',
//       inputTitle: 'Enter DELETE to continue',
//       matchText: 'DELETE',
//       onConfirm: this.handleDelete
//     });
//   },

//   // 4. Input data
//   showPasswordPrompt() {
//     this.$message.prompt({
//       title: 'Confirm',
//       message: 'Please enter your password to process',
//       inputType: 'password',
//       onConfirm: (password) => {
//         this.verifyPassword(password);
//       }
//     });
//   }
//   // 5. Confirm with match text
//   showDeleteConfirm() {
//     this.$confirmMatch({
//       message: 'Are you sure you want to delete account?',
//       matchText: 'CONFIRM',
//       onConfirm: this.handleDelete
//     });
//   }
